import { useContext, useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Master from '../Layouts/Master';

const Export = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [formRemoveId, setFormRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    getExcels();
  }, [search]);
  const getExcels = async () => {
    setLoading(true);
    await useApi.get(
      `/excel${search}`,
      {},
      (res) => {
        eventContext.exports = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeForm = async (excelExportId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/excel/${excelExportId}`,
      {},
      (res) => {
        success('فایل مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getExcels();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست فایل های اکسل
          </h1>
        </div>
        <button
          onClick={getExcels}
          className='btn bg-purple p-2 d-flex flex-row justify-content-center'
        >
          <i className='fad fa-sync text-dark-mode f-16 mx-2'></i>
          <span className='text-dark-mode f-12'>تازه کردن</span>
        </button>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.exports?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>دانلود</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.exports?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.name}</td>
                  <td>
                    {item.path == false ? (
                      <span className='d-flex justify-content-center f-12 badge badge-danger mx-auto badge-pill p-2'>
                        در حال ایجاد فایل
                      </span>
                    ) : (
                      <a
                        href={item.path}
                        target='_blank'
                        className='btn btn-info btn-sm d-flex flex-row  mx-auto justify-content-center p-2'
                      >
                        <i className='fad fa-download text-dark-mode f-15'></i>
                      </a>
                    )}
                  </td>
                  <td>
                    <div className='d-flex flex-row'>
                      <Link
                        className='mx-2'
                        to='#'
                        onClick={(e) => {
                          e.preventDefault();
                          setFormRemoveId(item.id);
                          setModalIsOpen(true);
                        }}
                      >
                        حذف
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <span className='f-13 font-weight-bold text-secondary'>
              هیج فایلی جهت نمایش یافت نشد
            </span>
          </div>
        )}
      </div>

      <div className='w-100 mt-4 d-flex'>
        <Pagination
          search={search}
          totalPage={eventContext.exports?.meta?.pagination?.total_pages}
          basePath={`/panel/excel`}
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف فایل مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeForm(formRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Export;
